export enum TagValueType {
    String="String",
    Number="Number",
    Boolean="Boolean",
    Enum_String="Enum_String"
}

export interface Tag {
    id: string
    source: "System"|"User"
    name: string
    label: string
    type: TagValueType
    meta: {
        isVersionCode?:boolean,
        versionCodePadding?:number,
        allowedValues?:{ label:string, value:string}[],
        displayOnListing?: boolean,
        editable?: boolean;
    }

}